import config from './_config'
import paths from './_paths'

export default (name, params = {}) => {
  return config()
    .get(paths[name], { params })
    .catch(error => {
      throw new Error(`Api Service GET ${paths[name]} Failed: ${error}`)
    })
}
